export const COOKIE_AUTH_TOKEN = "auth-token";
export const LS_USER = "user";
export const LS_LOCALE = "locale";
